/* eslint-disable prettier/prettier */
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { PaginationQuery } from "../../../../@types/pagination.types";

const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "assign";

export const getAssignedGroupsAndLocations = async (params: any) => {
	try {
		const endpoint = "assign";
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const assignGroups = async (_payload: any) => {
	const endpoint = `${initialRoute}/group`;
	const payload = JSON.stringify(_payload);
	const token = localStorage.getItem("@jwt");
	const response = await post(endpoint, payload, {
		...headers,
		[Authorization]: `${Bearer} ${token}`
	});
	if (response) {
		const {
			data: { message }
		} = response;
		if (message === MESSAGE.post.succ || message === MESSAGE.delete.succ) {
			const {
				data: { result }
			} = response;
			return result;
		}
	}
};

export const assignLocations = async (_payload: any) => {
	const endpoint = `${initialRoute}/location`;
	const payload = JSON.stringify(_payload);
	const token = localStorage.getItem("@jwt");
	const response = await post(endpoint, payload, {
		...headers,
		[Authorization]: `${Bearer} ${token}`
	});
	if (response) {
		const {
			data: { message }
		} = response;
		if (message === MESSAGE.post.succ || message === MESSAGE.delete.succ) {
			const {
				data: { result }
			} = response;
			return result;
		}
	}
};

export const assignAllGroups = async (_payload: any) => {
	const endpoint = `${initialRoute}/all-groups`;
	const payload = JSON.stringify(_payload);
	const token = localStorage.getItem("@jwt");
	const response = await post(endpoint, payload, {
		...headers,
		[Authorization]: `${Bearer} ${token}`
	});
	if (response) {
		const {
			data: { message }
		} = response;
		if (message === MESSAGE.post.succ) {
			const {
				data: { result }
			} = response;
			return result;
		}
	}
};

export const assignAllLocations = async (_payload: any) => {
	const endpoint = `${initialRoute}/all-locations`;
	const payload = JSON.stringify(_payload);
	const token = localStorage.getItem("@jwt");
	const response = await post(endpoint, payload, {
		...headers,
		[Authorization]: `${Bearer} ${token}`
	});
	if (response) {
		const {
			data: { message }
		} = response;
		if (message === MESSAGE.post.succ) {
			const {
				data: { result }
			} = response;
			return result;
		}
	}
};

export const getAssignedGroups = async (query: PaginationQuery) => {
	try {
		const endpoint = `${initialRoute}/groups`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

// eslint-disable-next-line arrow-parens
export const getAssignedGroupsCount = async () => {
	try {
		const endpoint = `${initialRoute}/groups-count`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const assignSelectedLocationsToTheGroup = async (_payload: any) => {
	const endpoint = `${initialRoute}/assign-selected-locations-to-the-groups`;
	const payload = JSON.stringify(_payload);
	const token = localStorage.getItem("@jwt");
	const response = await post(endpoint, payload, {
		...headers,
		[Authorization]: `${Bearer} ${token}`
	});
	if (response) {
		const {
			data: { message }
		} = response;
		if (message === MESSAGE.post.succ) {
			const {
				data: { result }
			} = response;
			return result;
		}
	}
};

export const assignGroupsAndLocations = {
	getAssignedGroupsAndLocations,
	assignGroups,
	assignLocations,
	assignAllGroups,
	assignAllLocations,
	getAssignedGroups,
	getAssignedGroupsCount,
	assignSelectedLocationsToTheGroup
};
